export var QuestionTypeEnum = {
    CHECKBOX: "checkbox",
    EMAIL: "email",
    NUMBER: "number",
    PHOTO: "photo",
    RADIO: "radio",
    SELECT: "select",
    SIGNATURE: "signature",
    TELEPHONE: "telephone",
    DATEPICKER: "date",
    TEXT: "text",
    END_SURVEY: "end-survey"
};

export class Option {
    constructor(key, caption, forwardTo) {
        this.key = key;
        this.label = caption;
        this.forwardTo = forwardTo;
    }

    static createSimple(key) {
        return new Option(key, key, null);
    }
}

export class Question {
    constructor(id, type, question, options, answer) {
        this.id = id;
        this.type = type;
        this.question = question;
        this.options = options;
        this.answer = answer;
        this.photoUrls = [];
    }

    static initDefault() {
        return new Question("", QuestionTypeEnum.END_SURVEY, "Een moment alstublieft...", [], null);
    }

    static initText() {
        return new Question("", QuestionTypeEnum.TEXT, "", [], null);
    }

    static initRadio() {
        return new Question("", QuestionTypeEnum.RADIO, "", [], null);
    }

    static initCheckBox() {
        return new Question("", QuestionTypeEnum.CHECKBOX, "", [], null);
    }

    static initSelect() {
        return new Question("", QuestionTypeEnum.SELECT, "", [], null);
    }

    static initSignature() {
        return new Question("", QuestionTypeEnum.SIGNATURE, "", [], null);
    }


    static initPhoto() {
        return new Question("", QuestionTypeEnum.PHOTO, "", [], null);
    }

    static initEmail() {
        return new Question("", QuestionTypeEnum.EMAIL, "", [], null);
    }

    static initNumber() {
        return new Question("", QuestionTypeEnum.NUMBER, "", [], null);
    }

    static initTelephone() {
        return new Question("", QuestionTypeEnum.TELEPHONE, "", [], null);
    }

    static createText(id, question) {
        return new Question(id, QuestionTypeEnum.TEXT, question, [], null);
    }

    static from(jsonString) {
        const parsedJSon = JSON.parse(jsonString);
        const qObject = Object.assign(new Question(), parsedJSon);
        if (qObject.options !== undefined) {
            qObject.options = qObject.options.map(eo => {
                eo.label = eo.caption;
                return eo;
            }).map(eo => Object.assign(new Option(), eo));
        }
        return qObject;
    }

    isTextBox() {
        return this.type === QuestionTypeEnum.TEXT;
    }

    isRadio() {
        return this.type === QuestionTypeEnum.RADIO;
    }

    isCheckBox() {
        return this.type === QuestionTypeEnum.CHECKBOX;
    }

    isSelectBox() {
        return this.type === QuestionTypeEnum.SELECT;
    }

    isEndSurvey() {
        return this.type === QuestionTypeEnum.END_SURVEY;
    }

    isTextField() {
        return this.isEmail() || this.isNumber();
    }

    isEmail() {
        return this.type === QuestionTypeEnum.EMAIL;
    }

    isPhoto() {
        return this.type === QuestionTypeEnum.PHOTO;
    }

    isNumber() {
        return this.type === QuestionTypeEnum.NUMBER;
    }

    isSignature() {
        return this.type === QuestionTypeEnum.SIGNATURE;
    }


    isTelephone() {
        return this.type === QuestionTypeEnum.TELEPHONE;
    }

    isNotEndSurvey() {
        return !this.isEndSurvey();
    }

    // keys must be an array of strings
    addOptions(keys) {
        const optionInternal = [];

        keys
            .map((e) => e.trim())
            .filter((e) => e !== "")
            .forEach((e) => {
                if (optionInternal.filter((o) => e === o).length === 0) {
                    optionInternal.push(e);
                }
            });

        this.options = optionInternal.map((e) => Option.createSimple(e));
    }

    resolveOptions() {
        if (this.options) {
            return this.options.filter((e) => !!e);
        }
        return [];
    }

    resolvePhotoUrls() {
        if (this.photoUrls) {
            return this.photoUrls;
        }
        return [];
    }
}
